export default __webpack_public_path__ + "static/media/rake-structure-cn.6f4c7232.webp";